/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-27 16:18:59
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-02 09:13:29
 */

export default {
    path: 'job',
    component: () => import(/* webpackChunkName: "task-list" */ '@/pages/job/TaskList'),
    meta: {title:'任务结算',cate:'结算管理'},
    children: [
        {
            path: 'import',
            component: () => import(/* webpackChunkName: "task-list" */ '@/pages/job/Import'),
            meta: {title:'结算清单excel'},
            hidden: true
        },
        {
            path: ':batch_id/send',
            component: () => import(/* webpackChunkName: "task-list" */ '@/pages/job/BatchSend'),
            meta: {title:'提交发放'},
            hidden: true
        },
        {
            path: ':batch_id/view',
            component: () => import(/* webpackChunkName: "task-list" */ '@/pages/job/BatchDetail'),
            meta: {title:'查看明细'},
            hidden: true
        },
        {
            path: 'batchDetails',
            component: () => import(/* webpackChunkName: "task-list" */ '@/pages/job/CreateEdit'),
            meta: {title:'发放详情'},
            hidden: true
        }
    ]
}